import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    console.log("Phone tracker connected")
  }

  // This method is called when a link target is clicked
  linkTargetConnected(element) {
    element.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick(event) {
    const link = event.currentTarget
    const businessProfileId = link.dataset.businessProfileId
    const phoneNumber = link.dataset.phoneNumber

    console.log("Phone click detected:", { businessProfileId, phoneNumber })

    if (!businessProfileId || !phoneNumber) {
      console.warn("Missing data for phone click tracking")
      return
    }

    // Track the click (don't prevent default - let the tel: link work)
    this.trackClick(businessProfileId, phoneNumber)
  }

  async trackClick(businessProfileId, phoneNumber) {
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      const response = await fetch('/phone_clicks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          business_profile_id: businessProfileId,
          phone_number: phoneNumber
        })
      })

      const result = await response.json()
      console.log("Phone click tracked:", result)

    } catch (error) {
      console.warn('Error tracking phone click:', error)
    }
  }
}
